import { VehicleFacadeBirdView } from '@euler/app/flows/report/components/VehicleFacadeBirdView';
import { Overlay } from '@euler/app/flows/report/components/VehicleFacadeBirdView.shared';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { getDefectiveLevel } from '@euler/functions/getDefectiveLevel';
import { InventoryQuery } from '@euler/functions/useInventory';
import {
  DefectiveLevel,
  FacadeSiteConfigurationMapByName,
  MediaObject,
} from '@euler/model';
import { SiteInspectionType } from '@euler/model/enum';
import { PreInspection, TaskMedia } from '@euler/model/task-detail';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

type ResultGroup = {
  name: string;
  siteId: number;
  code?: string | null;
  defectiveLevel: DefectiveLevel;
  medias: MediaObject[];
};

function toMediaObject(mediaInfo: TaskMedia): MediaObject {
  return {
    type: mediaInfo.type.startsWith('image/') ? 'image' : 'video',
    id: mediaInfo.cid,
    url: mediaInfo.url,
    coverUrl: mediaInfo.coverUrl,
  };
}

export const FacadeBirdView = memo(
  ({
    preInspection,
    inventoryQuery,
    style,
  }: {
    preInspection: PreInspection;
    inventoryQuery: InventoryQuery;
    style?: StyleProp<ViewStyle>;
  }) => {
    const map = FacadeSiteConfigurationMapByName;
    const overlays: Overlay[] = [];
    const groups: ResultGroup[] = [];
    for (const inspectedSite of preInspection.sites) {
      if (inspectedSite.inspectionType !== SiteInspectionType.Facade) {
        continue;
      }
      const site = inventoryQuery.getSiteById(inspectedSite.siteId);
      groups.push({
        siteId: inspectedSite.siteId,
        name: inspectedSite.name,
        defectiveLevel: getDefectiveLevel(
          inspectedSite.abnormalLevel,
          inspectedSite.severityLevel,
        ),
        code: site?.code,
        medias: inspectedSite.items.flatMap(x => x.medias.map(toMediaObject)),
      });
    }
    const groupsWithIssues = groups.filter(
      x => x.defectiveLevel !== DefectiveLevel.Fine,
    );
    for (const group of groupsWithIssues) {
      if (!map.has(group.name)) continue;
      const configuration = map.get(group.name)!;
      const color =
        group.defectiveLevel === DefectiveLevel.Urgent ? '#e0463d' : '#e0463d';
      overlays.push({
        name: configuration.name,
        imagePath: configuration.overlay,
        coords: configuration.coords,
        color,
      });
    }

    return (
      <LayoutProviderView
        css={`
          justify-content: center;
        `}
        style={style}
      >
        {({ width }) => (
          <VehicleFacadeBirdView overlays={overlays} size={width} />
        )}
      </LayoutProviderView>
    );
  },
);
